import './signIn.css';
import { useState } from 'react';

import BackgroundImg from '../../../components/backgroundImg/backgroundImg';
import SignInBackground from '../../../assets/sectionBackgrounds/signInBackground/signInBackground';
import Form from '../../../components/forms/form'

export default function SignIn({ onSignInSuccess }) {
  return (
    <div className="sign-in">

      <BackgroundImg background={<SignInBackground/>}/>

      <div className="sign-in-container">

        <Form 
        titleTag='Login to your dashboard'
        submitType={'handleLogin'}
        emailTag={true}
        passwordTag={true}
        typeOfButton='submit'
        onSignInSuccess = {onSignInSuccess}/>
        
      </div>
    </div>
  );
}